import { Button, Font, PlusValueIllustration } from 'is24-corecss';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { css } from '@emotion/css';
import { IconS24ArrowLeft24, IconS24InfoCircle24 } from '@is24/cosma-ui-icons';
import { CreditHistoryList } from './CreditHistoryList';
import { pageStyles } from './styles';
import { Msg, useIntl } from '@/i18n';
import { Loader } from '@/components/common/display/loader/Loader';
import { useGetCreditHistory } from '@/apiHooks/creditHistory.hook';
import { isNativeWebView } from '@/components/native-bridge';

export const CreditHistoryPage = () => {
  const navigate = useNavigate();
  const { t } = useIntl();
  const { initializing, creditHistory, isCreditHistoryError } = useGetCreditHistory();
  const showBackButton = !isNativeWebView();

  const handleBack = () => {
    navigate(-1);
  };

  const totalCredits = creditHistory?.totalCredits.toLocaleString('de-DE');

  return (
    <div className='margin-horizontal-l margin-vertical-l padding-bottom-xxl'>
      {showBackButton && (
        <div className='page-head-btn button-rounded button-rounded-text-default button-rounded-size-medium button-rounded-width-hug'>
          <Button textStyle onClick={handleBack} type='button' className={`text ${css(pageStyles.link)}`}>
            <span className='with-icon font-body-medium-bold'>
              <IconS24ArrowLeft24 width={16} height={16} fill='currentColor' className='margin-right-s' />
              <Msg id='creditsTransactionsLog.backButtonText' defaultMessage='Zurück' />
            </span>
          </Button>
        </div>
      )}
      <h1 className='font-heading-large-bold'>
        <Msg id='creditsTransactionsLog.title' defaultMessage='Your Suchen+ Credits' />
      </h1>
      <Font variant='font-heading-xsmall-regular'>
        {t({
          id: `creditsTransactionsLog.subTitle`,
          defaultMessage: 'Track your transactions in the credit history',
        })}
      </Font>
      <div className={`${css(pageStyles.container)} margin-top-l`}>
        <div
          className={`${css(pageStyles.header)} padding-horizontal-xl padding-vertical-s display-flex grid-align-center grid-justify-space-between`}
        >
          <div>
            <Font variant='font-heading-xlarge-bold' className='margin-none'>
              {totalCredits}
            </Font>
            <Font variant='font-heading-xsmall-regular'>Credits</Font>
          </div>
          <div>
            <PlusValueIllustration variant={'triple'} />
          </div>
        </div>
        <div className='padding-horizontal-l'>
          {initializing && <Loader styles={{ minHeight: '240px' }} size='medium' />}
          {!initializing && isCreditHistoryError && (
            <div className='padding-vertical-l display-flex align-items-center gap-s'>
              <IconS24InfoCircle24 width={24} height={24} color='blue' />
              <Font variant='font-body-medium-regular' className='margin-none'>
                {t({
                  id: `creditsTransactionsLog.creditFetchError`,
                  defaultMessage: 'Your data could not be loaded. Please try again later.',
                })}
              </Font>
            </div>
          )}
          {!initializing && !isCreditHistoryError && creditHistory && (
            <CreditHistoryList transactions={creditHistory.transactions} />
          )}
        </div>
      </div>
    </div>
  );
};
